<template>
  <div>
    <b-card no-body>
      <!-- Head -->
      <table-header
        search
        search-placeholder="Cari di sini"
        search-action="articleCategory/getCategoriesArticle"
      >
        <template #action>
          <b-button
            v-if="canAccess('manage', 'ArticleCategory')"
            variant="primary"
            :to="{ name: 'article-categories-create'}"
          >
            + Buat Kategori Artikel
          </b-button>
        </template>
      </table-header>

      <!-- Body -->
      <b-skeleton-table
        v-if="isPending"
        :rows="5"
        :columns="4"
      />
      <b-table
        v-else
        ref="refUserListTable"
        :items="articleCategories.data"
        responsive
        :fields="tableFields"
        primary-key="id"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        class="position-relative mh-160"
      >

        <!-- Column: Nama -->
        <template #cell(name)="data">
          {{ data.item.name }}
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canAccess('manage', 'ArticleCategory')"
          #cell(actions)="data"
        >
          <div class="text-nowrap text-right">
            <!-- Dropdown -->
            <table-action
              :actions="tableAction"
              :data="data"
            />
          </div>
        </template>

      </b-table>
      <!-- Footer -->
      <div class="mx-2 mb-2">
        <pagination
          :data="articleCategories.meta"
          action="articleCategory/getCategoriesArticle"
        />
      </div>
    </b-card>

    <b-modal
      v-if="canAccess('manage', 'ArticleCategory')"
      id="modal-delete"
      title="Apakah anda yakin"
      @hidden="deletedData = ''"
    >
      Ingin Menghapus Kategori Artikel ini?
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-secondary"
          :disabled="isDeleting"
          @click="cancel()"
        >
          Batalkan
        </b-button>
        <b-button
          variant="danger"
          :disabled="isDeleting"
          @click.prevent="handleDelete"
        >
          <b-spinner
            v-if="isDeleting"
            small
            label="Spinning"
          />
          {{ isDeleting ? 'Menghapus' : 'Ya, Hapus' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Ripple from 'vue-ripple-directive'
import {
  BSkeletonTable,
  BButton,
  BCard,
  BTable,
  VBTooltip,
  BModal,
} from 'bootstrap-vue'
import TableHeader from '@/layouts/components/custom/TableHeader.vue'
import Pagination from '@/layouts/components/custom/Pagination.vue'
import TableAction from '@/layouts/components/custom/TableAction.vue'

export default {
  components: {
    BButton,
    BSkeletonTable,
    BCard,
    BTable,
    BModal,
    TableHeader,
    Pagination,
    TableAction,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      tableFields: [
        { key: 'name', label: 'Nama' },
        { key: 'actions', label: '', thStyle: { width: '1%' } },
      ],
      searchKeyword: '',
      fixedSearchKeyword: '',
      isPending: false,
      isDeleting: false,
      deletedData: '',
    }
  },
  computed: {
    ...mapState('articleCategory', ['articleCategories']),
    query() {
      return this.$route.query
    },
    tableAction() {
      return [
        {
          access: null,
          to: 'article-categories-edit|id:id',
          action: '',
          icon: 'EditIcon',
          title: 'Edit',
        },
        {
          access: null,
          to: null,
          action: data => { this.deleteConfirmation(data.id) },
          icon: 'TrashIcon',
          title: 'Hapus',
        },
      ]
    },
  },
  async created() {
    await this.getCategoriesArticle(this.query)
  },
  methods: {
    ...mapActions('articleCategory', ['getCategoriesArticle', 'deleteCategoriesArticle']),
    deleteConfirmation(value) {
      this.$bvModal.show('modal-delete')
      this.deletedData = value
    },
    async handleDelete() {
      this.isDeleting = true
      await this.deleteCategoriesArticle({ articleCategoryId: this.deletedData })
      this.isDeleting = false
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>
